export default __webpack_public_path__ + "static/media/winqi-laptop.9bb1f891.png";